import { render, staticRenderFns } from "./setores.vue?vue&type=template&id=34a23b3a"
import script from "./setores.vue?vue&type=script&lang=js"
export * from "./setores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports